import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "AirHostと連携する方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/air-host/settings.jpg",
		url: "https://chillnn.notion.site/AirHost-31ffffe15c578054a9c9faebd71adb9e",
	},
];
